module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sunrise":"Sunrise","sunset":"Sunset","daylight":"Daylight","day1":"Sunday","day2":"Monday","day3":"Tuesday","day4":"Wednesday","day5":"Thursday","day6":"Friday","day7":"Saturday"}}')
  delete Component.options._Ctor
}
